import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import es from './locales/es';
import en from './locales/en';

const resources = {
	es: {
		translation: es
	},
	en: {
		translation: en
	}
};

i18n
	.use(initReactI18next)
	.use(LanguageDetector)
	.init({
		resources,
		fallbackLng: 'es',
		interpolation: {
			escapeValue: false
		},
		whitelist: ['es', 'en']
	});

export default i18n;
